import "./BakeryDashboard.css";

import DashboardHeader from "../../dashboard/DashboardHeader/DashboardHeader";
import DashboardStats from "../../dashboard/DashboardStats/DashboardStats";
import BusinessProgress from "../../dashboard/BusinessProgress/BusinessProgress";
import QuickActions from "../../dashboard/QuickActions/QuickActions";
import RecentOrders from "../../dashboard/RecentOrders/RecentOrders";
import RecentReviews from "../../dashboard/RecentReviews/RecentReviews";
import Notifications from "../../dashboard/Notifications/Notifications";
import RevenueChart from "../../dashboard/RevenueChart/RevenueChart";
function BakeryDashboard({
  provider,
  stats,
  refreshDashboard,
  setDrawerOpen,
}) {

  return (

    <div className="bakery-dashboard">

      <DashboardHeader
    provider={provider}
    setDrawerOpen={setDrawerOpen}
/>

      <DashboardStats
        stats={stats}
        provider={provider}
      />

      <div className="dashboard-row">

        <BusinessProgress
          stats={stats}
          provider={provider}
        />

        <QuickActions
          provider={provider}
        />

        <RecentOrders />


        <RecentReviews />
        <Notifications />
        <RevenueChart />

      </div>

    </div>

  );

}

export default BakeryDashboard;